import { ActionReducerMapBuilder } from "@reduxjs/toolkit";

import { LOGOUT_REQUEST_SUCCESS } from "containers/authentication/redux/actionTypes";
import { CHANGE_SELECTED_CLIENT } from "containers/clients/redux/actionTypes";

/**
 * Resets a slice when the selected client changes or the user logs out.
 */
export function addLifecycleResets<T>(
  builder: ActionReducerMapBuilder<T>,
  initialState: T,
) {
  builder
    .addCase(CHANGE_SELECTED_CLIENT, () => initialState)
    .addCase(LOGOUT_REQUEST_SUCCESS, () => initialState);
}
